var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium leading-4",class:'text-'+_vm.badge.textColor +' bg-'+ _vm.badge.bgColor},[_vm._v(" "+_vm._s(_vm.badge.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }